import styled from 'styled-components';

export const GenericTextLink = styled.a.attrs(() => ({
  className: 'font-medium text-indigo-600 hover:text-indigo-500',
}))``;
